import { Link } from 'react-router-dom';
import type { ReportSummary } from '../../services/reportApi';

interface ReportCardsProps {
  reports: ReportSummary[];
}

const currency = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});

function formatPercent(value: number) {
  const sign = value >= 0 ? '+' : '';
  return `${sign}${value.toFixed(2)}%`;
}

function isToday(date: string) {
  return date === new Date().toISOString().split('T')[0];
}

export default function ReportCards({ reports }: ReportCardsProps) {
  return (
    <div className="reports-list">
      {reports.map((report) => (
        <article key={report.date} className="report-card">
          <div className="report-card-header">
            <span className="report-date">
              {report.date}
              {isToday(report.date) && <span className="today-badge">오늘</span>}
            </span>
            <Link to={`/reports/${report.date}`} className="view-button">보기</Link>
          </div>

          <div className="report-card-body">
            <ReportStat label="총 자산" value={currency.format(report.total_value)} />
            <ReportStat
              label="일일 수익률"
              value={formatPercent(report.daily_return)}
              tone={report.daily_return >= 0 ? 'positive' : 'negative'}
            />
            <ReportStat label="거래" value={`${report.trades_count}건`} />
            <ReportStat label="포지션" value={`${report.positions_count}개`} />
          </div>
        </article>
      ))}
    </div>
  );
}

function ReportStat({ label, value, tone = '' }: { label: string; value: string; tone?: string }) {
  return (
    <div className="report-stat">
      <span className="stat-label">{label}</span>
      <span className={`stat-value ${tone}`}>{value}</span>
    </div>
  );
}
